import React, { FormEvent, ReactNode } from "react";

export const Form: React.FC<{
  onSubmit: (event: FormEvent) => void;
  children: ReactNode;
}> = ({ onSubmit, children }) => {
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit(event);
  };

  return <form onSubmit={handleSubmit}>{children}</form>;
};
